import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home/Home";
import Contact from "./pages/contact/Contact";
import Stock from "./pages/stock/Stock";

// Importa Firebase
import { app } from "./firebase/firebaseConfig"; // Asegúrate de que la ruta sea correcta

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta raíz que carga Home */}
        <Route path="/" element={<Home />} />
        
        {/* Otras rutas */}
        <Route path="/stock" element={<Stock />} />
        <Route path="/contact" element={<Contact />} />

        {/* Redirección opcional de "/Home" a "/" */}
        <Route path="/Home" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
